<template lang="html">
  <div id="blog-page">

    <section class="placed-backg header-banners-section-s1" v-bind:style="{ backgroundImage: 'url(public/images/pages/blog/banner-1.jpg)' }">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="box">
              <h1>EL BLOG</h1>

              <p class="p-lg">
                Entérate en todo momento de las noticias más relevantes del mundo del turismo.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="container articles-section">
      <div class="container">
        <div class="row box-articles">
          <div class="col-lg-6 col-article" v-for="(b, bInx) in blogs" :key="'bInx-'+bInx">
            <router-link class="t-250 box-article-s1" :to="'/blog/'+b.id">
              <div class="placed-backg t-250 box-image" v-bind:style="{ backgroundImage: 'url('+b.imageUrl+')' }"></div>

              <div class="box-info">
                <h5 class="t-250 title">{{ b.title }}</h5>

                <div class="descr" v-html="b.body">
                  
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  data() {
    return {
      blogs:[],
    }
  },
  methods:{
    getInfo(){
      axios.get(tools.url('/api/blogs')).then((response)=>{
        this.blogs = response.data;
      
      }).catch((error)=>{
        console.log(error);
      })
    },
  },
  mounted() {
      this.getInfo();
  },
}
</script>

